import { useQuery } from '@tanstack/react-query';

import { EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';

import { EApiRoutes, getApiRouteOrMock } from './api.utils';

export interface OrderFilterValues {
  displayOSGroups: Record<string, string[]>;
  states: string[];
}

export default function useOrderFilterValues(selectedProjects?: string) {
  const axios = useAxios();

  return useQuery<OrderFilterValues>({
    queryKey: [EQueryKeys.ORDER_FILTER_VALUES, selectedProjects],
    queryFn: async () => {
      const response = await axios.get(
        getApiRouteOrMock(EApiRoutes.ORDER_FILTER_VALUES),
        undefined,
        selectedProjects ? { 'x-publishers': selectedProjects } : undefined
      );

      return {
        displayOSGroups: response?.displayOSGroups ?? {},
        states: response?.states ?? []
      };
    },
    enabled: !!selectedProjects,
    refetchOnWindowFocus: false,
    retry: false
  });
}
